import React, { useMemo } from 'react';

import { useHistory } from 'react-router-dom';

import { QuickFilterButton } from '@hpstellar/core';
import { Typography } from '@hpstellar/core/visId';

import useSiteConfig from '../../hooks/useSiteConfig';

import './css/search-page-product-category-tiles.less';

const getCategoryTileProps = (Label, gtmValue, keyword, history, basename) => ({
    Label,
    gtmActions: new Map([
        [
            'linkClick',
            {
                gtmCategory: 'facet',
                gtmId: 'quick-filters',
                gtmValue,
                gtmFacetChecked: true
            },
        ],
    ]),
    onClick: () => {
        try{
            history.push(`${basename}/sitesearch?keyword=${keyword}`)
        }catch(e){}
    }
})

const getCategories = (history, basename) => {
    const laptopsKw = 'hp-laptops';
    const desktopsKw = 'hp-desktops';
    const printersKw = 'hp-printers';
    const displaysKw = 'displays-and-accessories';
    return [
        getCategoryTileProps('Laptops', laptopsKw, laptopsKw, history, basename),
        getCategoryTileProps('Desktops', desktopsKw, desktopsKw, history, basename),
        getCategoryTileProps('Printers', printersKw, printersKw, history, basename),
        getCategoryTileProps('Displays & Accessories', displaysKw, displaysKw, history, basename)
    ]
}

const SearchProductCategoryTiles = props => {
    const { searchKey, type } = props || {};
    const history = useHistory();
    const siteConfig = useSiteConfig();
    const { basename } = siteConfig || {};

    const categoryTiles = useMemo(() => {
        const categories = getCategories(history, basename);

        return categories.map(
            (categoryTile, idx) =>{
                const { Label, onClick, gtmActions } = categoryTile || {};
                return (
                    <QuickFilterButton
                        className="search-product-mobile-category-quick-filters"
                        key={idx}
                        gtmActions={gtmActions}
                        onClick={onClick}
                    >{Label}</QuickFilterButton>
                )
        })
    }, [history, basename]);

    const hasValidSearchKey = typeof searchKey === 'string' && searchKey.trim().length > 0;
    return categoryTiles && categoryTiles.length > 0 && (
        <div className="hawksearch-category-tiles-section">
            <div className={`search-results-text-and-category-section${hasValidSearchKey ? '' : ' srp-category-no-keyword'}`}>
                <div className='search-product-category-tiles-area'>
                    <div className="search-product-category-tiles-container">
                        <div className='srp-category-quick-filters'>
                            <Typography className='search-results-categories-text' variant='h4' tag='h4'>Categories</Typography>
                            {categoryTiles}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SearchProductCategoryTiles;
